import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StateStoring } from 'devextreme-react/data-grid';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import server from '../../_api/backend';
import * as toast from './toast';

export type Category = {
  categories: any;
  subCategories: any;
};
export const getBookCategories = createAsyncThunk(`bookCategories`, async () => {
  const list = await server.getCategories().then((payload) => {
    return payload;
  });

  const puchChildren: any = [];
  list.forEach((item: any) => {
    puchChildren.push(item.children);
  });
  return { categories: list, subCategories: puchChildren };
});

export const bookCategories = createSlice({
  name: 'bookCategories',
  initialState: { categories: [] } as Category,
  reducers: {
    getData(state): Category {
      return { ...state };
    },
  },
  extraReducers: {
    [getBookCategories.fulfilled.type]: (state, action: PayloadAction<any>) => {
      state.categories = action.payload.categories;
      state.subCategories = action.payload.subCategories;
    },
  },
});

export const { getData } = bookCategories.actions;
export default bookCategories.reducer;
